function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(130 130)",
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 158.25,
  cy: 102.75,
  r: 22.125
}), /*#__PURE__*/React.createElement("path", {
  d: "M.815 9.645L9.646.815l229.54 229.539-8.831 8.831zM54 22.5h132c17.37 0 31.5 14.13 31.5 31.5v81.834l-39.429 27.045 43.107 43.107c3.372-5.904 5.322-12.714 5.322-19.986V54c0-22.332-18.168-40.5-40.5-40.5H54c-7.269 0-14.082 1.95-19.986 5.319l6.672 6.672C44.736 23.592 49.239 22.5 54 22.5zM152.778 180.225L90 120l-67.5 54.141V54c0-4.761 1.092-9.264 2.994-13.314l-6.672-6.672C15.45 39.918 13.5 46.731 13.5 54v132c0 22.332 18.168 40.5 40.5 40.5h132c7.272 0 14.082-1.95 19.986-5.319l-45.939-45.942-7.269 4.986z"
}));

function SvgNoImageAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500
  }, props), _ref);
}

export default __webpack_public_path__ + "7338053447dbe29460c0f67157b93215.svg";
export { SvgNoImageAvailable as ReactComponent };